<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/system/businessManagement' }">企业管理</el-breadcrumb-item>
            <el-breadcrumb-item>定制权限</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div>
        <!-- <div class="role_name">
          <span>用户类型：</span>
          <el-select v-model="role_id" @change="changeRoleFn" filterable placeholder="请选择角色">
            <el-option
              v-for="item in roleListArr"
              :key="item.type"
              :label="item.name"
              :value="item.type">
            </el-option>
          </el-select>
        </div> -->
        <el-table
          :data="tableData"
          border
          :span-method='objectSpanMethod'
          style="width: 100%">
          <!-- <el-table-column
            type="selection"
            width="55">
          </el-table-column> -->
          <el-table-column
            prop="rightname"
            label="项目权限"
            width="180">
          </el-table-column>
          <el-table-column
            prop="page_rightname"
            label="页面权限"
            width="180">
          </el-table-column>
          <el-table-column
            label="操作权限">
             <template slot-scope="scope">
              <el-checkbox-group v-model="checkList">
                <el-checkbox @change="checkboxFn(scope.row)" v-for="(item) in scope.row.operate" :disabled="item.edtion_right" :key="item.code" :label="item.code">{{item.operate_rightname}}</el-checkbox>
              </el-checkbox-group>
            </template>
          </el-table-column>
        </el-table>
        </div>
        <el-button style="margin-top: 10px" type="primary" @click="submitFn">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "./api";
import commApi from "../../api/commonApi"
import {timestampToTime} from "@/mixins/tools.js"

export default {
  mixins: [timestampToTime],
  data() {
    return {
      checkList: [],
      disableList: [],
      tableData: [],
      nowType: '',
      roleListArr: [
        {type: 1, name: '试用'},
        {type: 2, name: '正式用户'},
      ],
      role_id: Number(this.$route.query.id)
    };
  },
  created() {
    this.adminInfo()
    // this.roleListFn()
  },
  methods: {
    changeRoleFn() {
      this.adminInfo(this.role_id)
    },
    checkboxFn(rows) {
      console.log(this.checkList)
    },
    submitFn() {
      let datas = {
        id: this.role_id,
        right_code: this.checkList.join(','),
      }
      api.editCompanyG(datas)
        .then(res => {
          if(res.error_code == 0) {
            this.$message.success("提交成功！！");
            this.$router.push({
              name: "businessManagement-G"
            });
          }
        })
        .catch(err => {
      });
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      const span = column['property'] + '-span'
      if(row[span]){
          return row[span]
      }
    },


    // 角色初始化
    roleListFn() {
      let datas = {
        type: this.nowType
      }
      api.rightcodeListG(datas)
      .then(res => {
        this.tableData = res.list
        this.tableData = mergeTableRow(this.tableData, ['rightname'])
        // this.adminInfo()
      })
      .catch(err => {
        // this.$message(err);
      });
    },
    // 编辑详情
    adminInfo() {
      let datas = {
        id: this.role_id
      }
      api.adminCompanyInfoG(datas)
      .then(res => {
        this.nowType = res.info.type
        if(res.info.gov_right_code) {
          this.checkList = res.info.right_code.split(",").map(Number)
        }
        
        // var editList = res.info.edition_rightcode.split(",").map(Number)
        // this.disableList = [...this.checkList].filter(x => [...editList].every(y => y !== x))
        // this.disableList = this.checkList.filter(item => editList.indexOf(item)> -1)
        
        this.roleListFn()
      })
      .catch(err => {
      });
    },

    // 取消
    cancelFn() {
      this.$confirm('取消页面将不会保存，是否确定？', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({
          name: "earlyWarning"
        });
      }).catch(() => {
      });
    }
  }
};

export function mergeTableRow(data, merge) {
  if (!merge || merge.length === 0) {
    return data
  }
  merge.forEach((m) => {
    const mList = {}
    data = data.map((v, index) => {
      const rowVal = v[m]
      if (mList[rowVal] && mList[rowVal].newIndex === index) {
        mList[rowVal]['num']++
        mList[rowVal]['newIndex']++
        data[mList[rowVal]['index']][m + '-span'].rowspan++
        v[m + '-span'] = {
          rowspan: 0,
          colspan: 0
        }
      } else {
        mList[rowVal] = { num: 1, index: index, newIndex: index + 1 }
        v[m + '-span'] = {
          rowspan: 1,
          colspan: 1
        }
      }
      return v
    })
  })
  return data
}
</script>

<style lang="scss" scoped>
.line {
  text-align: center;
  color: #8b8b8b;
}
.role_name {
  .el-input {
    width: 220px;
  }
  margin-bottom: 30px;
}
.data_font {
  span {
    font-weight: bold;
    margin-left: 20px;  
    margin-right: 10px;  
  }
}
</style>